import React, { Component } from 'react'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import Redactor from '~/Common-Objects/RedactorSwitch'
import clone from 'lodash/clone'
import { connect } from 'react-redux'
import SiteVars from '~/Classes/siteVars'
import axiosRaw from 'axios'
import axios from '~/data/http/axios'

@connect((store) => {
    return { user: store.user, accountMaster: store.accountMaster }
})
export default class DivStandalone extends Component {
    constructor(props) {
        super(props)
        this.clickCatcher = this.clickCatcher.bind(this)
        this.updateHtmlValue = this.updateHtmlValue.bind(this)
        this.state = {
            formHtml: ''
        }
        this.activeFormRevision = ''
        this._fetchSeq = 0
    }

    getFormButtonGlobals(globalVariables) {
        if (!globalVariables) return ''
        const style = globalVariables.formButtonStyle?.value ?? globalVariables.formButtonStyle
        const width = globalVariables.formButtonWidth?.value ?? globalVariables.formButtonWidth
        return JSON.stringify({ style, width })
    }

    async loadForms() {
        let content = this.props.elementData?.content?.value || ''
        let formHtml = ''

        let subFormBasicIds = []
        if (content.indexOf('{{subformbasic:') > -1) {
            subFormBasicIds = (content?.match(/\{\{subformbasic:{(.*?)}\}\}/g) || [])
                .map((match) => {
                    let id = match.replace('{{subformbasic:', '').replace('}}', '')
                    if (id.indexOf('_localVariables_') >= 0) {
                        id = DragDropFunctions.lookupLocalVariables(this.props.localVariables, id)
                    }
                    return id
                })
                .filter(Boolean)
        }
        if (subFormBasicIds.length) {
            const { data } = await axiosRaw.get(
                `${SiteVars.getConnString()}/form?am=${this.props.accountMaster.id}&fid=${subFormBasicIds[0]}&plain=true&_=${Math.round(Math.random() * 1000000)}`
            )
            formHtml += data?.html || ''
        }

        let subFormIds = []
        if (content.indexOf('{{subform:') > -1) {
            subFormIds = (content?.match(/\{\{subform:{(.*?)}\}\}/g) || [])
                .map((match) => {
                    let id = match.replace('{{subform:', '').replace('}}', '')
                    if (id.indexOf('_localVariables_') >= 0) {
                        id = DragDropFunctions.lookupLocalVariables(this.props.localVariables, id)
                    }
                    return id
                })
                .filter(Boolean)
        }
        if (subFormIds.length) {
            if (this.props.localVariables?.inputFields?.value?.length) {
                const { data } = await axios.post(
                    `/landingpage/${this.props.landingPageId}/inlineformpreview/${subFormIds[0]}`,
                    {
                        localVariables: this.props.localVariables,
                        globalVariables: this.props.globalVariables
                    }
                )
                formHtml += data?.html || ''
            }
        }
        if (formHtml !== this.state.formHtml) {
            this.setState({ formHtml: formHtml })
        }
    }

    componentDidMount() {
        this.loadForms()
    }

    componentDidUpdate(prevProps) {
        const localVariables = JSON.stringify(this.props.localVariables)
        const prevLocalVariables = JSON.stringify(prevProps.localVariables)
        const formButtonGlobals = this.getFormButtonGlobals(this.props.globalVariables)
        const prevFormButtonGlobals = this.getFormButtonGlobals(prevProps.globalVariables)
        if (
            localVariables !== prevLocalVariables ||
            formButtonGlobals !== prevFormButtonGlobals ||
            this.props.inlineFormContentDate !== prevProps.inlineFormContentDate
        ) {
            this.loadForms()
        }
    }

    clickCatcher(event) {
        event.preventDefault()
    }

    updateHtmlValue(value) {
        let existingValue = this.props.elementData?.content?.value || ''
        if (existingValue?.indexOf('_localVariables_') >= 0) {
            let localVariableName = existingValue.replace('_localVariables_.', '')
            let newPath = this.props.selectedElement.path + '.localVariables.' + localVariableName + '.value'
            this.props.updateElement(value, newPath, 'NONE')
        } else {
            var newObject = clone(this.props.elementData)
            newObject.content.value = value
            this.props.updateElement(newObject, this.props.path)
        }
    }

    render() {
        let eleProps = {}

        if (this.props.elementData.props) {
            eleProps =
                DragDropFunctions.generatePropsForStage(
                    this.props.elementData.props,
                    this.props.globalVariables,
                    'div',
                    this.props.localVariables
                ) || {}
        }

        if (this.props.elementData.content) {
            if (
                (this.props.elementData.content.type && this.props.elementData.content.type == 'html') ||
                (this.props.elementData.content.hasOwnProperty('editable') &&
                    this.props.elementData.content.editable === false)
            ) {
                if (eleProps && !eleProps.style) eleProps.style = {}
                eleProps.style.minHeight = '10px'

                let content = this.props.elementData.content.value

                let matches = content.match(/\{\{subformbasic:{(.*?)}\}\}/g)
                if (matches) {
                    matches.forEach((match) => {
                        content = content.replace(match, ``)
                    })
                }
                let subformMatches = content.match(/\{\{subform:{(.*?)}\}\}/g)
                if (subformMatches) {
                    subformMatches.forEach((match) => {
                        content = content.replace(match, ``)
                    })
                }

                if (!content || content.trim() === '') {
                    if (this.props.elementData.content.stagePlaceholder && !this.state.formHtml) {
                        content = this.props.elementData.content.stagePlaceholder
                    }
                }
                return (
                    <div>
                        <div {...eleProps}>
                            <div
                                dangerouslySetInnerHTML={{ __html: content }}
                                className='remove-all-styles'
                                onClick={this.clickCatcher}
                            />
                            {this.state.formHtml && (
                                <div style={{ position: 'relative' }}>
                                    <div
                                        style={{ pointerEvents: 'none' }}
                                        dangerouslySetInnerHTML={{ __html: this.state.formHtml }}
                                    />
                                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }} />
                                </div>
                            )}
                        </div>
                    </div>
                )
            }
        }

        const isSelected = this.props.selectedElement.path === this.props.currentParentPath

        if (this.props.elementData.content) {
            var thisContent = this.props.elementData.content.value || ''
            if (typeof thisContent !== 'string') thisContent = String(thisContent)
            if (thisContent.indexOf('_localVariables_') >= 0) {
                thisContent = DragDropFunctions.lookupLocalVariables(this.props.localVariables, thisContent) || ''
            }

            let redactorEle = null
            if (isSelected) {
                const elementUuid = this.props?.tuuid?.tuuid || ''
                const favoriteColors = this.props.elementsData.globalVariables.favoriteColors || []
                const color = eleProps?.style?.color || ''
                const overrideTools = this.props.elementData.content.redactorTools || undefined
                const overridePlugins = this.props.elementData.content.redactorPlugins || undefined
                const overrideInlinePopup = this.props.elementData.content.redactorInlinePopup || undefined
                const overrideMpTextFormatExcludedFormats =
                    this.props.elementData.content.redactorMpTextFormatExcludedFormats || undefined
                let allowParagraphs = true
                if (this.props.elementData.content.redactorAllowParagraphs !== undefined) {
                    allowParagraphs = this.props.elementData.content.redactorAllowParagraphs
                }
                const noOuterP = this.props?.elementData?.content?.redactorNoFinalP === true
                const noOuterDiv = this.props.elementData?.content?.redactorNoOuterDiv === true

                redactorEle = (
                    <Redactor
                        key={this.props.currentParentPath || elementUuid}
                        isLandingPage={this.props.isLandingPage}
                        campaign={this.props.campaign}
                        content={thisContent}
                        updateContent={this.updateHtmlValue}
                        defaultFont={eleProps?.style?.fontFamily || ''}
                        defaultColor={color || null}
                        globalColours={[]}
                        favoriteColors={favoriteColors}
                        elementsData={this.props.elementsData}
                        elementUuid={elementUuid}
                        overrideTools={overrideTools}
                        overridePlugins={overridePlugins}
                        overrideInlinePopup={overrideInlinePopup}
                        overrideMpTextFormatExcludedFormats={overrideMpTextFormatExcludedFormats}
                        allowParagraphs={allowParagraphs}
                        noOuterP={noOuterP}
                        noOuterDiv={noOuterDiv}
                    />
                )
            }

            const emptyButtonLabel = !thisContent && this.props.elementData.content.redactorNoOuterDiv === true
            return (
                <div {...eleProps}>
                    {isSelected && redactorEle}

                    {!isSelected && (
                        <div
                            style={
                                emptyButtonLabel
                                    ? { display: 'inline-block', minHeight: '1.2em', minWidth: '1em' }
                                    : undefined
                            }
                            dangerouslySetInnerHTML={{ __html: thisContent }}
                            onClick={this.clickCatcher}
                        />
                    )}
                    {this.props.children}
                </div>
            )
        } else {
            return <div {...eleProps}>{this.props.children}</div>
        }
    }
}
